// SystemDevice Action Types

///systemdevice/list
export const GET_SYSTEM_DEVICE_LIST = "GET_SYSTEM_DEVICE_LIST";
export const GET_SYSTEM_DEVICE_LIST_SUCCESS = "GET_SYSTEM_DEVICE_LIST_SUCCESS";
export const GET_SYSTEM_DEVICE_LIST_FAILURE = "GET_SYSTEM_DEVICE_LIST_FAILURE";

///epossystem/data
export const GET_EPOSSYSTEM_DATA = "GET_EPOSSYSTEM_DATA";
export const GET_EPOSSYSTEM_DATA_SUCCESS = "GET_EPOSSYSTEM_DATA_SUCCESS";
export const GET_EPOSSYSTEM_DATA_FAILURE = "GET_EPOSSYSTEM_DATA_FAILURE";

///systemdevice/create
export const CREATE_SYSTEM_DEVICE = "CREATE_SYSTEM_DEVICE";
export const CREATE_SYSTEM_DEVICE_SUCCESS = "CREATE_SYSTEM_DEVICE_SUCCESS";
export const CREATE_SYSTEM_DEVICE_FAILURE = "CREATE_SYSTEM_DEVICE_FAILURE";

///systemdevice/update
export const UPDATE_SYSTEM_DEVICE = "UPDATE_SYSTEM_DEVICE";
export const UPDATE_SYSTEM_DEVICE_SUCCESS = "UPDATE_SYSTEM_DEVICE_SUCCESS";
export const UPDATE_SYSTEM_DEVICE_FAILURE = "UPDATE_SYSTEM_DEVICE_FAILURE";

///systemdevice/delete
export const DELETE_SYSTEM_DEVICE = "DELETE_SYSTEM_DEVICE";
export const DELETE_SYSTEM_DEVICE_SUCCESS = "DELETE_SYSTEM_DEVICE_SUCCESS";
export const DELETE_SYSTEM_DEVICE_FAILURE = "DELETE_SYSTEM_DEVICE_FAILURE";
